module.exports = __webpack_public_path__ + "static/media/heike.cc4e0864.jpg";